export default "__VITE_ASSET__CKC06Dro__"